import Icon from 'veui/components/Icon'

Icon.register({
  filter: {
    paths: [
      {
        d: 'M30.65 23.48V43a2 2 0 01-3 1.74l-9.3-5.33a2 2 0 01-1-1.73v-14.2L2.98 9.12A3 3 0 015.1 4h37.8a3 3 0 012.12 5.12L30.65 23.48zm-9.3 13.04l5.3 3.03v-16.9a2 2 0 01.58-1.41L40.5 8h-33l13.26 13.24a2 2 0 01.58 1.41v13.87z'
      }
    ],
    width: '48',
    height: '48'
  }
})
